import { ReducerCreators } from '@reduxjs/toolkit';
import { LiveblocksState, COMMENT_FILTER } from './types';

export const reducers = (create: ReducerCreators<LiveblocksState>) => ({
  setCommentingMode: create.reducer((state, action: { payload: boolean }) => {
    state.isCommentingMode = action.payload;
  }),
  toggleCommentingMode: create.reducer((state) => {
    state.isCommentingMode = !state.isCommentingMode;
  }),
  requestCenterComment: create.reducer((state) => {
    state.centerCommentRequested += 1;
  }),
  centerCommentHandled: create.reducer((state) => {
    state.centerCommentRequested = 0;
  }),
  toggleShowCommentThreads: create.reducer((state) => {
    state.showCommentThreads = !state.showCommentThreads;
  }),
  setCommentFilter: create.reducer((state, action: { payload: COMMENT_FILTER }) => {
    state.commentFilter = action.payload;
  }),
  addOpenComment: create.reducer((state, action: { payload: string }) => {
    if (!state.openComments.includes(action.payload)) {
      state.openComments.push(action.payload);
    }
  }),
  removeOpenComment: create.reducer((state, action: { payload: string }) => {
    state.openComments = state.openComments.filter((id) => id !== action.payload);
  }),
  clearOpenComments: create.reducer((state) => {
    state.openComments = [];
  }),
  setTargetThreadId: create.reducer((state, action: { payload: string }) => {
    state.targetThreadId = action.payload;
  }),
  clearTargetThreadId: create.reducer((state) => {
    state.targetThreadId = null;
  }),
});
